// Кто шлёт запрос: веб-кабинет (включая колл-центр и доставку). Облако записывает сборку каждому
// созданному чеку и строке чека (cheque_products.client_build_id) — при разборе видно,
// откуда и какой выкладкой пришёл заказ.
//
// Номер в package.json при выкладке не меняется, поэтому версия = версия пакета + хеш
// бандла (main.<hash>.js): хеш новый на каждой сборке и однозначно указывает на выкладку.
// В режиме разработки хеша нет — версия «dev».
const CLIENT_APP = 'cabinet'

let clientVersion = null

function resolveClientVersion() {
	if (clientVersion !== null) return clientVersion
	let hash = null
	try {
		const scripts = Array.from(document.scripts || [])
		for (const script of scripts) {
			const match = /\/main\.([0-9a-f]{6,})\.js/i.exec(script.src || '')
			if (match) {
				hash = match[1].slice(0, 8)
				break
			}
		}
	} catch (e) {
		hash = null
	}
	const pkg = process.env.REACT_APP_VERSION || ''
	clientVersion = hash ? [pkg, hash].filter(Boolean).join('-') : 'dev'
	return clientVersion
}

// Постоянный id браузера: по нему облако отличает сеансы входа (журнал «Входы»),
// закрывает сеанс при выходе и отмечает последнюю активность. Переживает выход из логина —
// это id браузера, а не пользователя.
const DEVICE_ID_KEY = 'mison_device_id'

let deviceId = null

export function getDeviceId() {
	if (deviceId) return deviceId
	try {
		deviceId = localStorage.getItem(DEVICE_ID_KEY)
		if (!deviceId) {
			deviceId = window.crypto?.randomUUID
				? window.crypto.randomUUID()
				: `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
			localStorage.setItem(DEVICE_ID_KEY, deviceId)
		}
	} catch (e) {
		deviceId = deviceId || `web-${Date.now().toString(36)}`
	}
	return deviceId
}

export function getClientHeaders() {
	return {
		'X-Client-App': CLIENT_APP,
		'X-Client-Version': resolveClientVersion(),
		'X-Client-Platform': 'web',
		'X-Device-Id': getDeviceId(),
	}
}
